<script>
import DatePicker from "vue2-datepicker";
import { deleteBooking, updateServiceBooking } from "../../../api/services/booking.service";
import { required , email } from "vuelidate/lib/validators";

export default {
  props: {
    visible: Boolean,
    closeable: Boolean,
    booking: Object,
  },
  data() {
    return {
      submitted: false,
      bookingId: null,
      bookingTitle: null,
      type: null,
      startTime: null,
      endTime: null,
      endDate: null,
      bookingNote: null,
      deleteBookingSuccess: false,
      deleteBookingFailed: false,
      bookingDate: null,
      bookingEndDate: null,
      bookingTime: null,
      bookingEndTime: null,
      bookingStartDateObject: null,
      bookingEndDateObject: null,
      status: null,
      reserverName: null,
      reserverEmail: null,
      reserverTelephone: null,
      numOfPacks: null,
      totalPrice: null,
      extras: [],
      subPackage: null,
      editLongBookingFailed: false,
      editLongBookingSuccess: false,
    };
  },
  components: {
    DatePicker
  },
  computed: {
    showModal: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  mounted() {
    if (this.booking) {
      this.bookingId = this.booking.bookingId;
      this.bookingTitle = this.booking.bookingTitle;
      this.type = this.booking.type;
      this.startTime = new Date(this.booking.startTime);
      this.endTime = new Date(this.booking.endTime);
      this.bookingNote = this.booking.bookingNote;
      this.reserverName = this.booking.reserverName;
      this.reserverTelephone = this.booking.reserverTelephone;
      this.reserverEmail = this.booking.reserverEmail;
      this.totalPrice = this.booking.totalPrice;
      this.extras = this.booking.extras;
      this.staus = this.booking.status;
      this.subPackage = this.booking.subPackage;
      this.numOfPacks = this.booking.numOfPacks;
    }
    this.handleInitialBookingTime();
  },
  validations: {
    reserverName: {required},
    reserverEmail: {required, email},
    reserverTelephone: {required},
    bookingDate: {required},
    bookingTime: {required},
    bookingEndDate: {required},
    bookingEndTime: {required}
  },
  methods: {
    clickCloseButton() {
      this.$emit("close");
    },
    async clickDeleteBookingButton() {
      let deleteServiceBookingSuccess = await deleteBooking(this.bookingId);
      this.$refs['del-modal'].hide();
      if (deleteServiceBookingSuccess) {
        this.deleteBookingSuccess = true;
        this.$emit("reload");
      } else {
        this.deleteBookingFailed = true;
      }
    },
    //modifies start and end times to be displayed
    handleInitialBookingTime() {
      let startDay = null;
      let startMonth = null;
      let startYear = null;
      let endDay = null;
      let endMonth = null;
      let endYear = null;

      /********** Initial Start Booking Time Handling **********/

      //new date object is created for start time
      this.startTime = new Date(this.booking.startTime);
      //the date is formatted so that date is a two digit string
      startDay = ("0" + this.startTime.getDate()).slice(-2);
      //month is increased by 1 and formatted to be a two digit string
      startMonth = this.startTime.getMonth() + 1;
      startMonth = ("0" + startMonth).slice(-2);
      //year does not need to be formatted
      startYear = this.startTime.getFullYear();
      //booking date is formed by joining the above variables
      this.bookingDate = startYear.toString().concat("-").concat(startMonth.toString()).concat("-").concat(startDay.toString());
      this.bookingTime = this.startTime.toString().slice(16,21);
      this.bookingStartDateObject = this.booking.startTime;

      /********** Initial End Booking Time Handling **********/

      //new date object for end time is created
      this.endTime = new Date(this.booking.endTime);
      //the date is formatted so that date is a two digit string
      endDay = ("0" + this.endTime.getDate()).slice(-2);
      //month is increased by 1 and formatted to be a two digit string
      endMonth = this.endTime.getMonth() + 1;
      endMonth = ("0" + endMonth).slice(-2);
      //year does not need to be formatted
      endYear = this.endTime.getFullYear();
      //end date is formed by joining the above variables
      this.bookingEndDate = endYear.toString().concat("-").concat(endMonth.toString()).concat("-").concat(endDay.toString());
      this.bookingEndTime = this.endTime.toString().slice(16,21);
      this.bookingEndDateObject = this.booking.endTime;
    },
    //method to update service booking
    async updateServiceBookings() {
      this.submitted = true;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        //the updated booking object will be created and sent to the API call
        let bookingObject = {
          "id" : this.bookingId,
          "subPackage" : this.subPackage,
          "numOfPacks" : parseInt(this.numOfPacks),
          "startTime" : (this.bookingStartDateObject).toString(),
          "endTime" : (this.bookingEndDateObject).toString(),
          "totalPrice": this.totalPrice,
          "extras": this.extras,
          "reserverName": this.reserverName,
          "reserverEmail": this.reserverEmail,
          "reserverTelephone": this.reserverTelephone,
          "type" : this.type,
          "note" : this.bookingNote
        }
        try {
          //same API as updateServiceBooking can be used to update the long booking as well
          let response = await updateServiceBooking(bookingObject);
          if(response.id) {
            this.editLongBookingSuccess = true;
            //scrolls the modal to top so that the alert can be seen
            this.$refs[`${this.id}-modal`].$refs.body.scrollTop = 0;
            setTimeout(() => {
              this.$emit("reload");
            }, 2000);

          } else {
            //scrolls the modal to top so that the alert can be seen
            this.$refs[`${this.id}-modal`].$refs.body.scrollTop = 0;
            this.editLongBookingFailed = true;
          }
        } catch(error) {
          console.error(error);
          this.editLongBookingFailed = true;
        }
      }
    },
    //gets the new
    handleOnDateTimeChange() {
      //new date object created from selected date string
      let date_start = new Date(this.bookingDate);
      let date_end = new Date(this.bookingEndDate);
      //date is extracted by slicing the string date
      let split_date_start = date_start.toString().slice(0,15);
      let split_date_end = date_end.toString().slice(0,15);
      //correct date is created by adding selected time to selected date
      let full_date_start = split_date_start.concat(" ").concat(this.bookingTime);
      let full_date_end = split_date_end.concat(" ").concat(this.bookingEndTime);
      //date object created using selected date and time
      let start_date = new Date(full_date_start);
      let end_date = new Date(full_date_end);
      //sets date objects for sending with the API call
      this.bookingStartDateObject = start_date.toISOString();
      this.bookingEndDateObject = end_date.toISOString();
    }
  }
};
</script>

<template>
  <!-- Edit Event Model Model -->
  <b-modal
    :id="id"
    :ref="`${id}-modal`"
    v-model="showModal"
    :title="this.$i18n.t('booking.editBooking.longBookingTitle')"
    centered
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    scrollable
  >
  <form @submit.prevent="updateServiceBookings()">
    <div class="row mt-1 justify-content-center">
      <div class="col-md-12">
        <div class="row">
          <!-- Sucees and Failed Msg -->
          <div class="col-md-12 mb-3">
            <b-alert
              v-model="editLongBookingFailed"
              variant="danger"
              dismissible
              ><i class="bx bx-error-circle mr-2"></i
              >{{
                $t("booking.editBooking.bookingEditFailed")
              }}</b-alert
            >
            <b-alert
              v-model="editLongBookingSuccess"
              variant="success"
              dismissible
              ><i class="mdi mdi-check-all mr-2"></i
              >{{
                $t("booking.editBooking.bookingEditSuccess")
              }}</b-alert
            >
          </div>
          <div class="col-md-6">
            <div class="form-group mb-3">
              <label>{{
                $t("booking.createBooking.longBooking.startingDateLabel")
              }}</label>
              <br />
              <date-picker
                v-model="bookingDate"
                :first-day-of-week="1"
                :class="{ 'is-invalid': submitted && $v.bookingDate.$error }"
                lang="de"
                value-type="format"
                placeholder="yyyy:mm:dd"
                @input="handleOnDateTimeChange()"
              ></date-picker>
              <div v-if="submitted && $v.bookingDate.$error" class="invalid-feedback">
                <span v-if="!$v.bookingDate.required">{{ $t("booking.editBooking.inputValidationMessage") }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-3">
              <label>{{
                $t("booking.createBooking.longBooking.endingDateLabel")
              }}</label>
              <br />
              <date-picker
                v-model="bookingEndDate"
                :class="{ 'is-invalid': submitted && $v.bookingEndDate.$error }"
                :first-day-of-week="1"
                lang="de"
                value-type="format"
                placeholder="yyyy:mm:dd"
                @input="handleOnDateTimeChange()"
              ></date-picker>
              <div v-if="submitted && $v.bookingEndDate.$error" class="invalid-feedback">
                <span v-if="!$v.bookingEndDate.required">{{ $t("booking.editBooking.inputValidationMessage") }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <label>{{
              $t("booking.createBooking.outOfService.stratingTimeLable")
            }}</label>
            <br />
            <date-picker
              v-model="bookingTime"
              format="HH:mm"
              :class="{ 'is-invalid': submitted && $v.bookingTime.$error }"
              value-type="format"
              type="time"
              placeholder="hh:mm"
              @input="handleOnDateTimeChange()"
            ></date-picker>
            <div v-if="submitted && $v.bookingTime.$error" class="invalid-feedback">
              <span v-if="!$v.bookingTime.required">{{ $t("booking.editBooking.inputValidationMessage") }}</span>
            </div>
          </div>
          <div class="col-md-6">
            <label>{{
              $t("booking.createBooking.outOfService.endingTimeLabel")
            }}</label>
            <br />
            <date-picker
              v-model="bookingEndTime"
              :class="{ 'is-invalid': submitted && $v.bookingEndTime.$error }"
              format="HH:mm"
              value-type="format"
              type="time"
              placeholder="hh:mm"
              @input="handleOnDateTimeChange()"
            ></date-picker>
            <div v-if="submitted && $v.bookingEndTime.$error" class="invalid-feedback">
              <span v-if="!$v.bookingEndTime.required">{{ $t("booking.editBooking.inputValidationMessage") }}</span>
            </div>
          </div>
          <div class="col-md-12 mt-3">
            <label>{{
              $t("booking.createBooking.longBooking.reserverNameLabel")
            }}</label>
            <b-form-input
              for="text"
              v-model="reserverName"
              :class="{ 'is-invalid': submitted && $v.reserverName.$error }"
              :placeholder="
                this.$i18n.t(
                  'booking.createBooking.longBooking.reserverNamePlaceholder'
                )
              "
            ></b-form-input>
            <div v-if="submitted && $v.reserverName.$error" class="invalid-feedback">
              <span v-if="!$v.reserverName.required">{{ $t("booking.editBooking.inputValidationMessage") }}</span>
            </div>
          </div>
          <div class="col-md-12 mt-3">
            <label>{{
              $t("booking.createBooking.longBooking.reserverEmailLabel")
            }}</label>
            <b-form-input
              for="text"
              v-model="reserverEmail"
              :class="{ 'is-invalid': submitted && $v.reserverEmail.$error }"
              :placeholder="
                this.$i18n.t(
                  'booking.createBooking.longBooking.reserverEmailPlaceholder'
                )
              "
            ></b-form-input>
            <div v-if="submitted && $v.reserverEmail.$error" class="invalid-feedback">
              <span v-if="!$v.reserverEmail.required">{{ $t("booking.editBooking.inputValidationMessage") }}</span>
              <span v-if="!$v.reserverEmail.email">{{ $t("booking.editBooking.invalidEmailError") }}</span>
            </div>
          </div>
          <div class="col-md-12 mt-3">
            <label>{{
              $t("booking.createBooking.longBooking.reserverTelephoneLabel")
            }}</label>
            <b-form-input
              for="text"
              v-model="reserverTelephone"
              :class="{ 'is-invalid': submitted && $v.reserverTelephone.$error }"
              :placeholder="
                this.$i18n.t(
                  'booking.createBooking.longBooking.reserverTelephonePlaceholder'
                )
              "
            ></b-form-input>
            <div v-if="submitted && $v.reserverTelephone.$error" class="invalid-feedback">
              <span v-if="!$v.reserverTelephone.required">This value is required.</span>
            </div>
          </div>
          <div class="col-md-12 mt-3">
            <label>{{
              $t("booking.createBooking.longBooking.specialNoteLabel")
            }}</label>
            <br />
            <textarea
              v-model="bookingNote"
              class="form-control"
              :maxlength="225"
              rows="3"
              :placeholder="
                this.$i18n.t(
                  'booking.createBooking.outOfService.specialNotePlaceHolder'
                )
              "
            ></textarea>
          </div>
          <!-- Action Button -->
          <div class="col-md-12 mt-4">
            <b-button
              class="mr-2"
              variant="warning"
              type="submit"
            >
              <i class="bx bxs-edit mr-1"></i>
              {{ $t("general.buttons.edit") }}</b-button
            >
            <b-button
              class="mr-2"
              variant="danger"
              v-b-modal.del-modal-center
            >
              <i class="bx bxs-trash mr-1"></i>
              {{ $t("general.buttons.delete") }}</b-button
            >
            <b-modal
            id="del-modal-center"
            ref="del-modal"
            centered
            :title="this.$i18n.t('booking.editBooking.deleteBookingTitle')"
            title-class="font-18"
            hide-footer
            >
              <p class="mb-4">
                {{ $t("booking.editBooking.deleteBookingDescription") }}
              </p>
              <b-button variant="danger" class="mr-4" @click="clickDeleteBookingButton()">
                <em class="bx bxs-trash mr-1"></em>{{ $t("booking.editBooking.confirmDeleteButton") }}
              </b-button>
              <b-button variant="light" data-dismiss="modal" @click="$bvModal.hide('del-modal-center')">
                <em class="bx bx-x mr-1"/>{{ $t("general.buttons.cancel") }}
              </b-button>
            </b-modal>
            <b-button variant="light" @click="clickCloseButton()">
              <i class="bx bx-x mr-1"></i>
              {{ $t("general.buttons.cancel") }}</b-button
            >
          </div>
        </div>
      </div>
    </div>
  </form>
  </b-modal>
</template>